module.exports = __webpack_public_path__ + "static/media/rock_win.419fbb68.png";